import type { Pulse } from '@sbt-web/tracking';

interface ViewTrackingAction {
  pulseInstance: Pulse;
  userId: string;
  score?: number;
  reviewCount?: number;
}

export const viewTrackingAction = ({
  pulseInstance,
  userId,
  score,
  reviewCount,
}: ViewTrackingAction): void => {
  pulseInstance.queueEvent({
    type: 'View',
    object: {
      '@type': 'UIElement',
      '@id': 'sdrn:subito:content:rating_profile:element:view_rating',
      label: `Profile view with rating-reviewCount=${reviewCount}-score=${score}`,
      'spt:custom': {
        score,
        reviewCount,
      },
    },
    target: {
      '@id': `sdrn:subito:user:${userId}`,
      '@type': 'Account',
      accountId: `${userId}`,
    },
  });
};
